export class ChangePassword {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(changepasswordrequest) {
        console.log("ChangePassword repository", changepasswordrequest)
      return await this.userRepository.changePassword(changepasswordrequest);
    }
  }